import styled from 'styled-components';
import { ReactElement } from 'react';

import { NumberPatternType } from '@dreryk/react-common';
import { NumberInput, QuestionmarkCircleIcon, StyledFlex, Tooltip } from '@dreryk/react-components';

import { integrationTranslationKeys } from '../translations';

import { DocplannerIntegrationFormController } from './integration.types';

type SynchronizationDaysCountFieldProps = {
   readonly register: DocplannerIntegrationFormController['register'];
};

const StyledQuestionIconWrapper = styled.div`
   height: 18px;
   width: 18px;
   fill: ${(props) => props.theme.primary};
`;
StyledQuestionIconWrapper.displayName = 'StyledQuestionIconWrapper';

// TODO DREGAB-11988 Poprawić działanie propa "size"
const StyledNumberInput = styled(NumberInput)`
   max-width: 261px;

   > div > div {
      max-width: 80px;
   }
`;

const DEFAULT_SYNCHRONIZATION_DAYS_COUNT = 7;

export const SynchronizationDaysCountField = (props: SynchronizationDaysCountFieldProps): ReactElement => {
   return (
      <StyledFlex gap={'4px'}>
         <StyledNumberInput
            testId={'synchronizationDaysCount'}
            label={integrationTranslationKeys.synchronizationDaysCount}
            controller={props.register('synchronizationDaysCount', { required: true })}
            defaultValue={DEFAULT_SYNCHRONIZATION_DAYS_COUNT}
            pattern={NumberPatternType.POSITIVE_INTEGER}
            min={1}
            max={160}
         />
         <Tooltip
            testId={'synchronizationDaysCount'}
            content={integrationTranslationKeys.synchronizationDaysCountDescription}
         >
            <StyledQuestionIconWrapper>
               <QuestionmarkCircleIcon />
            </StyledQuestionIconWrapper>
         </Tooltip>
      </StyledFlex>
   );
};
